<template>
  <div class="wrapper wrapper_pc">
    <common-nav></common-nav>
    <img src="../assets/imgs/barrageGame/banner.png" alt="">
    <BusinessContent v-show="isShowBusinessContent"></BusinessContent>
    <GameInfo v-show="isShowGameInfo" :options="options"></GameInfo>
    <Recruit v-show="isShowRecruit"></Recruit>
    <common-footer
        class="animate__animated animate__fadeInUp animate__delay-02s"
    ></common-footer>
  </div>
</template>

<script>
import BusinessContent from "../components/barrageGame/BusinessContent";
import GameInfo from "../components/barrageGame/GameInfo";
import Recruit from "../components/barrageGame/Recruit.vue";
import CommonFooter from "../components/common/CommonFooter.vue";
import CommonNav from "../components/common/CommonNav.vue";

export default {
  name: "Home",
  data: function () {
    return {
      isShowBusinessContent: true,
      isShowGameInfo: false,
      isShowRecruit: false,
      options:{
        isShowGame2: false,
        isShowGame3: false,
        isShowGame4: false,
        isShowGame5: false,
        isShowGame6: false,
      }
    };
  },
  components: {
    CommonNav,
    BusinessContent,
    GameInfo,
    Recruit,
    CommonFooter,
  },
  mounted() {
    window.addEventListener('scroll', () => {
      const scrollTop = document.documentElement.scrollTop
      if (scrollTop >= 975) {
        this.isShowGameInfo = true
      }
      if (scrollTop >= 1720) {
        this.options.isShowGame2 = true
      }
      if (scrollTop >= 2475) {
        this.options.isShowGame3 = true
      }
      if (scrollTop >= 2925) {
        this.options.isShowGame4 = true
      }
      if (scrollTop >= 3925) {
        this.options.isShowGame5 = true
      }
      if (scrollTop >= 4425) {
        this.options.isShowGame6 = true
      }
      if (scrollTop >= 5475) {
        this.isShowRecruit = true
      }
    })
  },
  methods: {},
};
</script>

<style lang="stylus" scoped>
.wrapper {
  width: 100%;
  background: #fff;
}

.hms_login_banner {
  .hms_center {
    width: 1400px;
    height 448px
    overflow hidden
    margin: 0 auto;
  }
}

.center_bg {
  position: relative;
  width: 100%;
}
</style>
